// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23SDo","newExpiryDate":"styles_newExpiryDate__2Op-_","footer":"styles_footer__-1-dA"};